import { chakra, StyleProps } from "@chakra-ui/react";
export const ArrowUp = (props: StyleProps) => (
  <chakra.svg {...props} viewBox="0 0 24 274">
    <path
      d="M13.06.94a1.5 1.5 0 0 0-2.12 0l-9.547 9.545a1.5 1.5 0 1 0 2.122 2.122L12 4.12l8.485 8.486a1.5 1.5 0 1 0 2.122-2.122L13.06.94ZM13.5 274V2h-3v272h3Z"
      fill="currentColor"
    />
  </chakra.svg>
);
